var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChampagne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C9.44772 2 9 2.44772 9 3C9 3.55228 9.44772 4 10 4V6.76393C10 6.91918 9.96385 7.07229 9.89443 7.21115L8.10557 10.7889C8.03615 10.9277 8 11.0808 8 11.2361V11.75H16V11.2361C16 11.0808 15.9639 10.9277 15.8944 10.7889L14.1056 7.21115C14.0361 7.07229 14 6.91918 14 6.76393V4C14.5523 4 15 3.55228 15 3C15 2.44772 14.5523 2 14 2H10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.25H16V18.25H8V13.25ZM10.2914 16.0457L11.598 17.2816C11.82 17.4917 12.18 17.4917 12.402 17.2816L13.7086 16.0457C14.0971 15.6782 14.0971 15.0823 13.7086 14.7148C13.32 14.3473 12.6901 14.3473 12.3015 14.7148L12 15L11.6985 14.7148C11.3099 14.3473 10.68 14.3473 10.2914 14.7148C9.90286 15.0823 9.90286 15.6782 10.2914 16.0457Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.75V20C8 21.1046 8.89543 22 10 22H14C15.1046 22 16 21.1046 16 20V19.75H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampagne);
export default __webpack_public_path__ + "static/media/champagne.62582cb734689c81e13cb59b9bed2744.svg";
export { ForwardRef as ReactComponent };